import React from 'react';
import { areas } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function Areas() {
  return <section className="bg-cream" data-id="element-46" data-mp="2cmjjjcyfdco5">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-28" data-id="element-47" data-mp="2cpp7govbi8ia">
        <SectionHeading eyebrow="Las 9 áreas del Bagua" title={<>
              ¿Qué querés potenciar <span className="text-clay" data-id="element-49" data-mp="2mm20dkj1gibz">en este momento</span> de tu vida?
            </>} data-id="element-48" data-mp="2rk3k87oagloi" />

        <ul className="mx-auto mt-12 grid max-w-4xl grid-cols-2 gap-3.5 sm:mt-16 sm:grid-cols-4 sm:gap-5" data-id="element-50" data-mp="1ywpt4q79ukcb">
          {areas.map(area => <li key={area.label} className="group flex flex-col items-center rounded-2xl bg-white px-3 py-7 text-center shadow-card transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-51" data-mp="1tuqoze3pjjeb">
              <span className="text-[26px] sm:text-[28px]" aria-hidden="true" data-id="element-52" data-mp="23sy3lqaixpd5">
                {area.icon}
              </span>
              <span className="mt-3 font-display text-[16px] font-semibold text-ink sm:text-[17.5px]" data-id="element-53" data-mp="1b6lqal1wqomd">
                {area.label}
              </span>
              <span className="mt-auto pt-2 text-[12px] leading-snug text-ink-mute sm:text-[12.5px]" data-id="element-54" data-mp="nuz6ihsballa">
                {area.detail}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center text-[15px] leading-[1.75] text-ink-soft sm:mt-14 sm:text-[16.5px]" data-id="element-55" data-mp="wou331fdb3pb">
          Armonía Interior te enseña qué observar y qué cambios podés realizar{' '}
          <span className="font-medium text-ink" data-id="element-56" data-mp="4y7g7oecr67q">según aquello que hoy querés trabajar.</span>
        </p>
      </div>
    </section>;
}